import React from "react";

const ImageViewer = ({ url }) => {
    return <img src={`https://tickets.morabaaapps.com${url}`} />;
};

export default ImageViewer;
